import { Seo } from "@/components/Seo";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page">
      <Seo
        title="Privacy Policy — Shineni India"
        description="How Shineni India (Madneel Ventures Pvt. Ltd.) collects, uses and protects information submitted through this website."
      />
      <section className="border-b border-border bg-white">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
          <h1 className="font-display text-4xl font-semibold text-indigo">Privacy Policy</h1>
          <p className="mt-3 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>
        </div>
      </section>
      <section className="mx-auto max-w-4xl space-y-8 px-4 py-14 text-sm leading-relaxed text-foreground/80 sm:px-6">
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Who we are</h2>
          <p className="mt-2">This website is operated by Madneel Ventures Pvt. Ltd. for its brand Shineni India, based in Faridabad, Haryana, India.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">What we collect</h2>
          <p className="mt-2">When you submit an enquiry, we collect the details you provide: your name, company, country, email address, WhatsApp number, product interest, quantities, specifications and destination. We also record the submitting IP address for spam prevention.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">How we use it</h2>
          <p className="mt-2">We use your details only to respond to your enquiry, prepare quotations and conduct resulting business communication. We do not sell, rent or share your information with third parties for marketing.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Storage & retention</h2>
          <p className="mt-2">Enquiries are stored securely in our systems and accessible only to authorised personnel. You may ask us to delete your enquiry data at any time by contacting us through this website.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Cookies & analytics</h2>
          <p className="mt-2">This site may use privacy-respecting analytics to understand visitor traffic. No advertising trackers are used.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Contact</h2>
          <p className="mt-2">For any privacy question or data request, write to us through the Contact page of this website.</p>
        </div>
      </section>
    </div>
  );
}
